import { LayoutGrid, List } from 'lucide-react';

export const ViewToggle = ({ view, setView }: { view: string; setView: (view: string) => void }) => {
  return (
    <div className="flex items-center bg-gray-100 rounded-xl p-1">
      <button
        onClick={() => setView('list')}
        className={`px-3 py-1.5 rounded-lg flex items-center gap-2 text-sm ${
          view === 'list' ? 'bg-teal text-white' : 'text-gray-600'
        }`}
      >
        <List size={16} /> List
      </button>
      <button
        onClick={() => setView('grid')}
        className={`px-3 py-1.5 rounded-lg flex items-center gap-2 text-sm ${
          view === 'grid' ? 'bg-teal text-white' : 'text-gray-600'
        }`}
      >
        <LayoutGrid size={16} /> Grid
      </button>
    </div>
  );
};
